@if (show) {
  <ul  class="breadcrumbs">
    @for (breadcrumb of breadcrumbs; let last = $last; track breadcrumb.label) {
      @if (!last) {
        <a [routerLink]="breadcrumb.url">{{ breadcrumb.label | translate }}</a>
      }
      @if (last) {
        <span>{{ breadcrumb.label | translate }}</span>
      }
    }
  </ul>
}
